<template>
  <div class="content-wrapper">    
    <!-- Content Header (Page header) -->
    <section class="content-header">
      <h1>
        Database Marketing Campaigns
      </h1>
      <ol class="breadcrumb">
        <li><a href="#"><i class="fa fa-dashboard"></i> Home</a></li>
        <li>Campaigns</li>
        <li class="active">Campaign List</li>
      </ol>      
    </section>

    <!-- Main content -->
    <section class="content">   
      <div class="row">
        <div class="col-md-12">
          <div class="box box-default margin-bottom-0px">
            <div class="box-header with-border">
              <h3 class="box-title">Campaign List</h3>
              <div class="action-button pull-right">
                <div class="form-group col-xs-12 col-sm-3" v-if="!isDeletedSelected">                  
                  <label for="date-from">Status</label>
                  <div class="input-group">
                      <nv-select class="form-control"  @change="searchOpportunityWithSelectedCriteria" style="width:250px"
                        id="ddlSelect" v-model="status">
                          <option value="">-- All --</option>
                          <option v-for="data in statusList" :key="data.id" :value="data.id" 
                          :selected="data === status">{{data.status}}</option>                      
                      </nv-select>
                  </div>
                </div>
                <div class="form-group col-xs-12 col-sm-3" style="flex-wrap: nowrap !important;">
                  
                     <label for="date-from">Start Date</label>
                    <div class="input-group">
                        <input type="date" v-model="fromDt" id="date-from" class="form-control" placeholder="From" v-on:keyup="searchOpportunityWithSelectedCriteria" @change="searchOpportunityWithSelectedCriteria"   />
                        <span class="input-group-addon" id="basic-addon2"><i class="fa fa-times" aria-hidden="true" @click="clearDate('fromDt')"></i></span>
                    </div>
                </div>
                <div class="form-group col-xs-12 col-sm-3">
                    <label for="date-to">End Date</label>
                     <div class="input-group">
                        <input type="date" v-model="toDt" id="date-to" class="form-control" placeholder="To" v-on:keyup="searchOpportunityWithSelectedCriteria" @change="searchOpportunityWithSelectedCriteria" />
                        <span class="input-group-addon" id="basic-addon2"><i class="fa fa-times" aria-hidden="true" @click="clearDate('toDt')"></i></span>
                    </div>
                 </div>
                  <div class="form-group col-xs-12 col-sm-6 search-opportunity">
                    <label for="date-to">Search</label>
                    <div>
                      <input type="text" placeholder="Type here to search and press 'Enter'"
                        v-reset-input='' v-on:keyup="searchOpportunityWithSelectedCriteria" class="search-box-reset form-control mrgn-right-20px searchBox" 
                        v-model="searchOpportunity"/>
                    </div>      
                  </div>
                    <div class="form-group col-xs-12 col-sm-6 create-opportunity">
                    <label for="date-to"></label>
                    <router-link class="btn btn-primary" :to="`/opportunity`">Create Campaign</router-link>
                  </div></div>
            </div>
              <!-- /.box-header -->
            <div class="loader" v-if="actionInProgress">
              <img src="/static/assets/loader/nivi-loader.svg" />
            </div>
            <div class="box-body">
              <ul class="nav nav-tabs" role="tablist">
                <li role="presentation" class="active"><a href="#saved" aria-controls="saved" role="tab" data-toggle="tab" @click="tabChange('saved')">Saved Campaigns</a></li>
                <li role="presentation"><a href="#deleted" aria-controls="deleted" role="tab" data-toggle="tab" @click="tabChange('Deleted')">Deleted Campaigns</a></li>
              </ul>
               <div class="tab-content">
                <div role="tabpanel"  class="tab-pane active" id="saved">
                  <table class="table table-striped table-apps">
                    <thead class="thead-dark">
                      <th class="padding-left5px">Campaign Name <i class="fa fa-long-arrow-up" @click="sortOpportunity('opportunity_name','asc', 'saved')"></i><i class="fa fa-long-arrow-down" @click="sortOpportunity('opportunity_name','desc', 'saved')"></i></th>
                      <th>Customer Name <i class="fa fa-long-arrow-up" @click="sortOpportunity('customer_name','asc', 'saved')"></i><i class="fa fa-long-arrow-down" @click="sortOpportunity('customer_name','desc', 'saved')"></i></th>
                      <th class="padding-left5px">Country</th>                  
                      <th class="align-center">Created On</th>                  
                      <th class="align-center">Status</th>
                      <th class="align-center">Test Nudge</th>
                      <th class="align-center">Change To</th>
                      <th class="align-center">Clone/Copy</th>
                      <th class="align-center">Edit</th>
                      <th class="align-center">Delete</th>
                    </thead>
                    <tbody>
                      <tr v-if="opportunityList.length === 0 && !loading"><td colspan="10" align="center">No Result found.</td></tr>
                      <tr v-show="opportunityList.length" v-for="(opportunity, index) in opportunityList" :key="index">
                        <td>{{opportunity.opportunity_name}}</td>
                        <td>{{opportunity.customer_name}}</td>
                        <td>{{opportunity.country_name}}</td>
                         <td class="align-center">
                          <span v-if="opportunity.created">{{formatDate(opportunity.created, 'd/M/Y hh:ss')}}</span>
                          <span v-if="!opportunity.created">--</span>
                        </td>                    
                        <td class="align-center">
                          <span v-if="opportunity.opportunity_status === 0">Draft</span>
                          <span v-if="opportunity.opportunity_status === 1">Active</span>
                          <span v-if="opportunity.opportunity_status === 2">Expired</span>
                          <span v-if="opportunity.opportunity_status === 3">Deleted</span>
                        </td>
                        <td class="align-center"><input v-if="(!opportunity.is_in_session) && opportunity.group_list && opportunity.group_list.length" type="button" class="btn btn-primary btn-sm center"  @click="testNudgeClick(opportunity)" value="Send Test"></td>
                        <td class="align-center">
                          <span v-for="status in changeOpportunityStatusMap[opportunity.opportunity_status]" :key="status" style="margin-right:10px">
                            <span :class="status.class" style="cursor:pointer"  @click="showOpportunityStatusUpdatePopup(opportunityStatusMap[status.status], opportunity.opportunity_status, index)">{{ status.status }}</span>
                          </span>
                        </td>
                        <td class="align-center">
                          <router-link :to="`/opportunity/${opportunity.id}/copyOpportunity`">
                            <input type="button" class="btn btn-primary btn-sm center" value="Copy Campaign">
                          </router-link>
                        </td>
                        <td class="align-center">
                          <router-link :to="`/opportunity/${opportunity.id}`"><i class="fa fa-edit" aria-hidden="true"></i></router-link>
                          </td>
                        <td class="align-center">
                          <i class="fa fa-times-circle link-action-color" aria-hidden="true" @click="showOpportunityDeleteConfirmationPopup(opportunity,index)"></i>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="pagination-container">
                    <paginate v-if="savedPageCount > 0"  :page-count="savedPageCount" :click-handler="getDataForSavedPage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
                  </div> 
                </div>
                <div role="tabpanel" class="tab-pane" id="deleted">
                  <table class="table table-striped table-apps">
                    <thead class="thead-dark">
                      <th class="padding-left5px">Campaign Name <i class="fa fa-long-arrow-up" @click="sortOpportunity('opportunity_name','asc', 'deleted')"></i><i class="fa fa-long-arrow-down" @click="sortOpportunity('opportunity_name','desc', 'deleted')"></i></th>
                      <th class="padding-left5px">Customer Name <i class="fa fa-long-arrow-up" @click="sortOpportunity('customer_name','asc', 'deleted')"></i><i class="fa fa-long-arrow-down" @click="sortOpportunity('customer_name','desc', 'deleted')"></i></th>
                      <th class="padding-left5px">Country</th>                  
                      <th class="align-center">Created On</th>                  
                      <th class="align-center">Status</th>
                    </thead>
                    <tbody>
                      <tr v-if="deletedOpportunityList.length === 0 && !loading"><td colspan="10" align="center">No Result found.</td></tr>
                      <tr v-show="deletedOpportunityList.length" v-for="(opportunity, index) in deletedOpportunityList" :key="index">
                        <td>{{opportunity.opportunity_name}}</td>
                        <td>{{opportunity.customer_name}}</td>
                        <td>{{opportunity.country_name}}</td>
                        <td class="align-center">
                          <span v-if="opportunity.created">{{formatDate(opportunity.created, 'd/M/Y hh:ss')}}</span>
                          <span v-if="!opportunity.created">--</span>
                        </td>                    
                        <td class="align-center">
                          <span >Deleted</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div class="pagination-container">
                    <paginate v-if="deletedPageCount > 0"  :page-count="deletedPageCount" :click-handler="getDataForDeletedPage" :prev-text="'Prev'" :next-text="'Next'" :container-class="'pagination'"></paginate>
                  </div> 
                </div>
              </div>
            </div>
          </div>
        </div>  
      </div>       
    </section>
    
    <form @submit.prevent="sendTestNudge"  method="post">
    <div class="modal-backdrop" v-if="audienceSelectionVisible" id="userSelection">
      <div class="modal modal-md modal-user-selection">
          <div class="test-nudge-container">
            <slot name="body">
              <div class="form-horizontal">

                <div class="row">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12">
                    <label class="control-label modal-label" for="search">Select Group:</label>
                    &nbsp;&nbsp;
                    <div style="display: flex; flex-flow: wrap;">
                      <div v-for="group in selectedReengagement.group_list" :key="group.group_name" style="width: 233px;">
                        <label class="radio-inline campaign-group-details" style="display: flex; flex-direction: column; margin-bottom: 10px; padding-left: 20px;"
                            v-bind:class="{'reengagement-group-disabled': !group.msg_template_id }">
                          <input type="radio" v-model="selectedGroup" :value="group" :disabled="!group.msg_template_id" />
                          <div>{{group.group_name}}</div>
                          <div>Nudge: <span class="campaign-details-text">{{group.msg_template_name ? group.msg_template_name : '-'}}</span></div>
                          <div>Split Percent: <span class="campaign-details-text">{{group.split_percent || group.split_percent === 0 ? group.split_percent + '%' : '-'}}</span></div>
                        </label>
                      </div>
                    </div>
                    <span v-if="submittedTestNudge && !$v.selectedGroup.required" class="text-red pull-right" style="margin-right: 20px">Please select a group.</span>
                  </div>
                </div>   

                <div class="row">
                  <div class="form-group col-xs-12 col-sm-12 col-md-12">
                    <label class="control-label modal-label" for="search">Select test user(s):</label>
                    <label class="hint-text">Only onboarded users appear here. To include your account in a test, make sure you're currently onboarded to the correct country.</label>
                    &nbsp;&nbsp;
                    <div class="users-checkbox-container">
                      <div v-for="user in userList" :key="user.account_id">
                        <label class="checkbox-inline col-xs-6 col-sm-6 col-md-5 col-lg-4">
                          <input type="checkbox" v-model="selectedUsers" :value="user"/>{{user.account_name}}
                        </label>
                      </div>
                      <div v-if="!userList.length">There are no users </div>
                    </div>
                    <span v-if="submittedTestNudge && !$v.selectedUsers.required" class="text-red pull-right" style="margin-right: 20px">Please select users to send message.</span>
                  </div>
                </div>   

              </div>
            </slot>
          </div>
          <div class="modal-footer" style="margin-top: auto; padding: 0px">
            <div class="form-group pull-right">
              <div class="col-sm-12">
                <button type="button" class="btn btn-primary" @click="closeAudienceSelection">Cancel</button>
                <button type="submit" class="btn btn-primary">Send Test</button> 
              </div>
            </div>
          </div>
      </div>
    </div>
    </form>

      <opportunityStatusChangeModal
        v-if="isOppStatusChangeConfirmationVisible"        
        @close="closeConfirmationModal" 
        @deleteOpportunity="deleteOpportunity"
        @updateOpportunityStatus="updateOpportunityStatus"
        :isOppStatusChangeConfirmationVisible="isOppStatusChangeConfirmationVisible"
        :confirmationMessage="confirmationMessage" 
        :actionToBePerformed="actionToBePerformed"
        />
        <opportunityReportModal 
        v-if="isOppReportModalVisible"
        @close="closeReport"
        :opportunityReport="opportunityReport"        
        :isOppReportModalVisible="isOppReportModalVisible" 
        :modalTitle="modalTitle" />

        <opportunityStatusAlertModal 
        v-if="isOppStatusAlertModalVisible"
        @close="closeAlert"
        :alertTitle="alertTitle"        
        :warningMessage="warningMessage"
        :opportunityStatus="opportunityStatus"
        :isOppStatusAlertModalVisible="isOppStatusAlertModalVisible" 
         />

    
    <BlockUI v-if="loading"><i class="fa fa-cog fa-spin fa-3x fa-fw"></i><br/>Please wait...</BlockUI>   
  </div>  
  
</template>
<script>
import api from '../../../utils/api'
import opportunityStatusChangeModal from './../popup/deleteConfirmation'
import opportunityReportModal from './opportunityReport'
import opportunityStatusAlertModal from './opportunityStatusAlert'
import _ from 'lodash'
import { required } from 'vuelidate/lib/validators'
import { formatDate, getSelectorValue } from '../../../utils/utilities'
import Paginate from 'vuejs-paginate'
import { opportunityStatusMap, changeOpportunityStatusMap } from './constants'

export default {
  name: 'opportunityDashboard',
  components: {
    'opportunityStatusChangeModal': opportunityStatusChangeModal,
    'opportunityReportModal': opportunityReportModal,
    'opportunityStatusAlertModal': opportunityStatusAlertModal,
    'paginate': Paginate
  },
  async mounted () {
    await this.getAllOpportunities()
    await this.getAllOpportunities(true)
    this.loading = false
  },
  validations: {
    selectedUsers: { required },
    selectedGroup: { required }
  },
  data () {
    return {
      deletedPageCount: 0,
      deletedCurrentPage: 1,
      savedPageCount: 0,
      savedCurrentPage: 1,
      pageSize: 20,
      formatDate: formatDate,
      opportunitySearchResult: [],
      keywordObj: {},
      searchOpportunity: '',
      status: '',
      loading: false,
      actionInProgress: false,
      isModalVisible: false,
      isOppStatusChangeConfirmationVisible: false,
      isOppReportModalVisible: false,
      isOppStatusAlertModalVisible: false,
      validationErrors: [],
      opportunityList: [],
      clonedOpportunityList: [],
      deletedOpportunityList: [],
      clonedDeletedOpportunityList: [],
      actionToBePerformed: 'Create Campaign',
      modalTitle: 'Campaign Report',
      alertTitle: '',
      warningMessage: '',
      confirmationMessage: 'Are you sure you want to delete this link?',
      rowIndexToBeUpdated: 0,
      fromDt: '',
      toDt: '',
      dateRange: '',
      opportunityReport: [
        {
          group_name: '',
          offeredCount: 0,
          messagesFailed: 0,
          messagesFailedReasons: [],
          options: [
            {
              responseCount: 0,
              clickedCount: 0,
              type: '',
              display_name: ''
            }
          ]
        }
      ],
      currentStatus: '',
      newStatus: '',
      opportunityStatusMap: opportunityStatusMap,
      changeOpportunityStatusMap: changeOpportunityStatusMap,
      audienceSelectionVisible: false,
      selectedUsers: [],
      selectedGroup: null,
      userList: [],
      submittedTestNudge: false,
      statusList: [
        { id: 0, status: 'Draft' },
        { id: 1, status: 'Active' },
        { id: 2, status: 'Expired' }
      ],
      isDeletedSelected: false
    }
  },
  methods: {
    clearDate (dateName) {
      if (dateName === 'fromDt') {
        this.fromDt = ''
      }
      if (dateName === 'toDt') {
        this.toDt = ''
      }
      if (this.fromDt === '' && this.toDt === '') {
        this.getAllOpportunities()
        this.getAllOpportunities(true)
      }
    },
    copyOpportunity (opportunityObj) {
      localStorage.setItem('opportunityData', opportunityObj)
    },
    tabChange (tab) {
      if (tab === 'Deleted') {
        this.isDeletedSelected = true
      } else {
        this.isDeletedSelected = false
      }
    },
    searchOpportunityWithSelectedCriteria (event) {
      this.deletedCurrentPage = 1
      this.savedCurrentPage = 1
      if (this.searchOpportunity !== '' && this.searchOpportunity !== undefined) {
        if (event.key === 'Enter') {
          this.getAllOpportunities()
          this.getAllOpportunities(true)
        }
      } else if ((this.fromDt && this.toDt) || event.currentTarget.id === 'ddlSelect') {
        this.getAllOpportunities()
        this.getAllOpportunities(true)
      }
    },
    closeConfirmationModal () {
      this.isOppStatusChangeConfirmationVisible = false
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Create Campaign'
      }, 500)
    },
    closeReport () {
      this.isOppReportModalVisible = false
    },
    closeAlert () {
      this.isOppStatusAlertModalVisible = false
    },
    showOpportunityStatusUpdatePopup (newStatus, currentStatus, index) {
      if (newStatus === 0) {
        this.actionToBePerformed = 'Draft Campaign'
        this.confirmationMessage = 'Are you sure you want to save this Campaign as Draft?'
      }
      if (newStatus === 1) {
        this.actionToBePerformed = 'Activate Campaign'
        this.confirmationMessage = 'Are you sure you want to Activate this Campaign?'
      }
      this.currentStatus = currentStatus
      this.newStatus = newStatus
      this.isOppStatusChangeConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },
    showOpportunitySuspendConfirmationPopup (opportunityList, index) {
      let opportunityData = this.opportunityList[index]
      // console.log('opportunityData', opportunityData)
      if (opportunityData.opportunity_status === 2) {
        this.isOppStatusAlertModalVisible = true
        this.alertTitle = 'Opportunity Alert'
        this.warningMessage = 'This Campaign has already been suspeneded.'
      } else {
        this.actionToBePerformed = 'Suspend Campaign'
        this.confirmationMessage = 'Are you sure you want to Suspend this Campaign?'
        this.isOppStatusChangeConfirmationVisible = true
        this.rowIndexToBeUpdated = index
      }
    },
    showOpportunityDeleteConfirmationPopup (opportunityList, index) {
      this.actionToBePerformed = 'Delete Campaign'
      this.confirmationMessage = 'Are you sure you want to Delete this Campaign?'
      this.isOppStatusChangeConfirmationVisible = true
      this.rowIndexToBeUpdated = index
    },
    updateOpportunityStatus () {
      this.loading = true
      const deletedRowData = this.opportunityList[this.rowIndexToBeUpdated]
      deletedRowData.opportunity_status = this.newStatus
      deletedRowData.current_status = this.currentStatus
      const params = deletedRowData
      var self = this
      self.closeModal()
      api.buildRequest('updateOpportunityStatus', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            if (response.status === 200) {
              self.isOppStatusChangeConfirmationVisible = false
              this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Link activated successfully'
              })
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isOppStatusChangeConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    onResetsearchOpportunity () {
      this.getAllOpportunities()
      this.getAllOpportunities(true)
    },
    async getAllOpportunities (isDeleted = false) {
      let skip = 0
      let selector = {}
      selector.isdeleted = false
      if (isDeleted) {
        if (this.deletedCurrentPage > 1) {
          skip = (this.deletedCurrentPage - 1) * this.pageSize
        }
      } else {
        if (this.savedCurrentPage > 1) {
          skip = (this.savedCurrentPage - 1) * this.pageSize
        }
      }
      if (this.searchOpportunity !== '' && this.searchOpportunity !== undefined) {
        selector.keyword = { $regex: this.searchOpportunity, $options: 'i' }
      }
      if (this.status !== '') {
        selector.status = this.status
      }
      if ((Date.parse(this.toDt) < Date.parse(this.fromDt))) {
        this.$swal({
          type: 'error',
          text: 'End date should be greater than Start date'
        })
        return false
      }
      this.loading = true
      let queryParams = {
        selector: getSelectorValue(selector),
        skip: skip,
        limit: this.pageSize,
        searchText: (this.searchOpportunity || '').replace(/'/g, "''"),
        fromDt: this.fromDt || '',
        toDt: this.toDt || '',
        sort: {
          createdAt: -1
        },
        isDeleted: isDeleted
      }
      if (this.status !== '' && !isDeleted) {
        queryParams['status'] = this.status
      }

      return new Promise(resolve => {
        api.buildRequest('getOpportunityList', 'POST', queryParams)
            .then(response => {
              this.loading = false
              if (response.status === 200) {
                if (isDeleted) {
                  if (response.data.payload.opportunityList.length > 0) {
                    this.deletedOpportunityList = response.data.payload.opportunityList
                    this.deletedPageCount = Math.ceil(response.data.payload.opportunityCount / this.pageSize)
                  } else {
                    this.deletedOpportunityList = []
                    this.deletedPageCount = 0
                    if (this.searchOpportunity === '') {
                    }
                  }
                } else {
                  if (response.data.payload.opportunityList.length > 0) {
                    this.opportunityList = response.data.payload.opportunityList
                    this.opportunityCount = parseInt(response.data.payload.opportunityCount)
                    this.clonedOpportunityList = this.opportunityList
                    this.savedPageCount = Math.ceil(response.data.payload.opportunityCount / this.pageSize)
                  } else {
                    this.opportunityList = []
                    this.clonedOpportunityList = this.opportunityList
                    this.savedPageCount = 0
                    if (this.searchOpportunity === '') {
                    }
                  }
                }
              } else {
                console.log('something went wrong')
              }
              resolve(true)
            }).catch(({ response }) => {
              resolve(true)
              this.loading = false
              this.$swal({
                type: 'error',
                text: response ? response.data.payload.message : 'An error occurred'
              })
            })
      })
    },
    closeModal () {
      this.rowIndexToBeUpdated = 0
      this.isModalVisible = false
      this.isOppStatusChangeConfirmationVisible = false
      this.validationErrors = []
      var self = this
      setTimeout(function () {
        self.actionToBePerformed = 'Add Keyword'
      }, 500)
    },
    deleteOpportunity () {
      this.loading = true
      console.log('delete opp called')
      const deletedRowData = this.opportunityList[this.rowIndexToBeUpdated]
      this.opportunityList.splice(this.rowIndexToBeUpdated, 1)
      this.closeModal()
      const params = deletedRowData
      var self = this
      api.buildRequest('deleteOpportunity', 'POST', params)
          .then(response => {
            self.loading = false
            self.rowIndexToBeUpdated = 0
            if (response.status === 200) {
              self.isOppStatusChangeConfirmationVisible = false
              this.getAllOpportunities(true).then(() => this.$swal({
                type: 'success',
                text: response && response.data && response.data.payload && response.data.payload.message ? response.data.payload.message : 'Opportunity deleted successfully'
              }))
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            self.isOppStatusChangeConfirmationVisible = false
            self.actionInProgress = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    getDataForDeletedPage (pageNum) {
      this.deletedCurrentPage = pageNum
      this.getAllOpportunities(true)
    },
    getDataForSavedPage (pageNum) {
      this.savedCurrentPage = pageNum
      this.getAllOpportunities()
    },
    onChangePage (pageOfItems) {
      // update page of items
      this.pageOfItems = pageOfItems
    },
    sortOpportunity (sortKey, order, action) {
      if (action === 'deleted') {
        this.deletedOpportunityList = _.sortBy(this.deletedOpportunityList, [sortKey], function (opp) {
          return opp[sortKey].toLowerCase()
        })
        if (order === 'desc') {
          this.deletedOpportunityList = _.reverse(this.deletedOpportunityList)
        }
      } else {
        this.opportunityList = _.sortBy(this.opportunityList, [sortKey], function (opp) {
          return opp[sortKey].toLowerCase()
        })
        if (order === 'desc') {
          this.opportunityList = _.reverse(this.opportunityList)
        }
      }
    },
    getOpportunityReport (opportunity, index) {
      this.loading = true
      this.modalTitle = 'Opportunity Report'
      var self = this
      api.buildRequest('getOpportunityReport', 'POST', opportunity)
          .then(response => {
            self.loading = false
            if (response.status === 200) {
              self.isOppReportModalVisible = true
              self.opportunityReport = response.data.payload
              console.log(this.opportunityReport)
            } else {
              console.log('something went wrong')
            }
          }).catch(({ response }) => {
            self.closeModal()
            self.rowIndexToBeUpdated = 0
            this.isOppReportModalVisible = false
            self.loading = false
            this.$swal({
              type: 'error',
              text: response ? response.data.payload.message : 'An error occurred'
            })
          })
    },
    async testNudgeClick (opportunity) {
      this.selectedReengagement = opportunity

      this.loading = true
      try {
        // const remData = await api.buildRequest('fetchCampaignDetails', 'GET', { campaignId: campaign.id })
        // this.selectedReengagement = remData.data.payload

        const response = await api.buildRequest('getUsersToSendTestNudges', 'POST', {countryId: opportunity.country_id})
        this.userList = response.data.payload.filter(i => i.id !== 0).map(i => { return { ...i, label: i.query_name } })
        this.audienceSelectionVisible = true
        this.loading = false
      } catch (err) {
        this.audienceSelectionVisible = true
        this.loading = false
        this.selectedUsers = []
        this.selectedGroup = null
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },
    async sendTestNudge () {
      this.submittedTestNudge = true
      this.$v.$touch()
      if (this.$v.$invalid) {
        return
      }
      try {
        this.audienceSelectionVisible = false
        this.loading = true
        this.submittedTestNudge = false
        this.selectedGroup.country_id = this.selectedReengagement.country_id
        this.selectedGroup.country = this.selectedReengagement.country_name
        this.selectedGroup.context = 'OE_GROUP'
        this.selectedGroup.opportunity_id = this.selectedReengagement.id
        const response = await api.buildRequest('sendTestNudge', 'POST',
          {
            campaign: this.selectedGroup,
            audience: this.selectedUsers
          }
        )
        this.loading = false
        this.$swal({
          type: 'success',
          text: response ? response.data.payload : 'Message sent successfully'
        })
        this.selectedUsers = []
        this.selectedGroup = null
      } catch (err) {
        this.loading = false
        this.audienceSelectionVisible = true
        this.$swal({
          type: 'error',
          text: err.response ? err.response.data.payload.message : 'An error occurred'
        })
      }
    },
    closeAudienceSelection () {
      this.audienceSelectionVisible = false
      this.submittedTestNudge = false
      this.selectedUsers = []
      this.selectedGroup = null
    }
  },
  watch: {
    searchOpportunity: function () {
      console.log('watching searchOpportunity')
      if (this.searchOpportunity === '') {
        this.deletedCurrentPage = 1
        this.savedCurrentPage = 1
        this.getAllOpportunities()
        this.getAllOpportunities(true)
      }
    }
  },
  computed: {
    filteredList () {
      this.opportunitySearchResult = this.opportunityList.filter(keyword => {
        return keyword.id.toLowerCase().includes(this.searchOpportunity.toLowerCase()) || keyword.data.name.toLowerCase().includes(this.searchOpportunity.toLowerCase())
      })
      return this.opportunitySearchResult
    }
  }
}
</script>
<style>
.search-box-reset {
  /* position: relative;
  cursor: default;
  top: -30px!important;
  left: 230px; */
    position: relative;
    cursor: default;
    top: 0px!important;
    left: 0px;
}
.align-center {
  text-align: center !important;
}
.search-opportunity {
  margin-top: 0px;
  margin-left: 0px;
}
.create-opportunity {
  margin-top: 24px !important;
}
.mrgn-right-20px {
  margin-right: 20px;
}
.loader {
  z-index: 9999;
  position: fixed;
  transform: translate(-50%,-50%);
  top:50%;
  left:50%;
}
.noaction {
  cursor: pointer;
  pointer-events: none;
}
.pagination {
  display: inline-block;
  margin-top: 0;
}

.pagination a {
  color: black;
  float: left;
  padding: 8px 16px;
  text-decoration: none;
}
.searchBox {
  width: 250px;
}
.pagination-container {
  display: flex;
  justify-content: flex-end;
  padding: 0 15px;
}
.margin-bottom-0px {
  margin-bottom: 0px; 
}
.cursor-pointer {
  cursor: pointer;
}
.thead-dark {
  background-color: #f5f5f5;
  border-color: #ddd;
  height: 40px;
}
.padding-left5px {
  padding-left: 5px;
}
.link-action-color {
  color:#0D9488
}
</style>


// WEBPACK FOOTER //
// opportunityList.vue?267ed3e4